<template>
  <div class="modal-overlay">
    <div id="ledger_print" class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Accounts Receivable Ledger</h5>
        <button type="button" class="close exclude-print" @click="closeModal">
          &times;
        </button>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          font-weight: bold;
          font-size: 2em;
          color: black;
          height: 50vh;
        "
        v-if="loading"
      >
        Loading...
      </div>

      <div v-if="!loading" class="modal-body">
        <div class="ledger-info">
          <p>Invoice ID: {{ invoice_id }}</p>
        </div>

        <table class="table">
          <thead>
            <tr style="background-color: rgb(235, 234, 232)">
              <th>Date</th>
              <th>Description</th>
              <th>Invoice No.</th>
              <th>Receipt No.</th>
              <th>Billed</th>
              <th>Paid</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ format_time(invoice.created_at) }}</td>
              <td>Cumulative Invoice Amount</td>
              <td>{{ invoice_id }}</td>
              <td>{{ "--" }}</td>
              <td>{{ total_bill }}</td>
              <td>{{ "--" }}</td>
            </tr>
            <tr v-for="payment in payments" :key="payment.id">
              <td>{{ format_time(payment.created_at) }}</td>
              <td>
                Invoice Bill Payment ({{
                  get_payment_method(payment.payment_method)
                }})
              </td>
              <td>{{ payment.invoice_id }}</td>
              <td>{{ payment.receipt_id }}</td>
              <td>{{ "--" }}</td>
              <td>{{ payment.amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!loading" class="modal-footer exclude-print">
        <button
          type="button"
          class="btn btn-secondary"
          @click="download_PDF('ledger_print', invoice_id + '_ledger')"
        >
          Print
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import downloadPDF from "../../../prints/div_to_pdf";
import { generalApiRequest } from "../../../api/apiIndex";
import utc_to_local from "../../../timezone/utc_local_time";
export default {
  name: "LedgerModal",
  props: {
    invoice_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payments: [],
      total_bill: "",
      invoice: {},
      loading: true,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-accounts-legger-modal");
    },
    get_payment_method(meth_id) {
      let method;
      switch (meth_id) {
        case "1":
          method = "Cash";
          break;
        case "2":
          method = "Mpesa";
          break;
        case "3":
          method = "Card";
          break;
        default:
          method = "Unknown";
          break;
      }
      return method;
    },
    format_time(param) {
      return utc_to_local(param);
    },
    formatCurrency(amount) {
      return "₦" + amount.toLocaleString();
    },
    download_PDF(div_id, doc_name) {
      return downloadPDF(div_id, doc_name);
    },
    async requestLedgerData() {
      this.loading = true;
      const url = "request_ledger_data/for_invoice";
      const data = await generalApiRequest(
        url,
        "GET",
        { invoice_id: this.invoice_id },
        1
      );

      this.payments = data.payments;
      this.total_bill = data.total_bill;
      this.invoice = data.invoice;
      this.loading = false;
      console.log(data);
    },
  },
  mounted() {
    this.requestLedgerData();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 1rem;
}

.close {
  background: rgb(233, 22, 22);
  border: none;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
  padding: 0 0.6rem;
  border-radius: 4px;
}

.ledger-table {
  width: 100%;
  border-left: 1px solid #ccc;
  border-collapse: collapse;
  margin-top: 1rem;
}

.ledger-table th,
.ledger-table td {
  border-top: 1px solid #ccc;
  /* border-left: 1px solid #ccc; */
  padding: 0.5rem;
  text-align: center;
}

.ledger-info {
  margin-bottom: 1rem;
}

.ledger-info h3 {
  margin: 0;
}
</style>
